import { render, staticRenderFns } from "./Resolution.vue?vue&type=template&id=a63a9aac&"
import script from "./Resolution.vue?vue&type=script&lang=js&"
export * from "./Resolution.vue?vue&type=script&lang=js&"
import style0 from "./Resolution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports